import React from 'react';
import { useTranslation } from 'react-i18next';

const HowItWorksSection = () => {
  const { t } = useTranslation();
  
  const steps = [
    {
      num: t('howItWorks.step1Num'),
      title: t('howItWorks.step1Title'),
      desc: t('howItWorks.step1Desc')
    },
    {
      num: t('howItWorks.step2Num'),
      title: t('howItWorks.step2Title'),
      desc: t('howItWorks.step2Desc')
    },
    {
      num: t('howItWorks.step3Num'),
      title: t('howItWorks.step3Title'),
      desc: t('howItWorks.step3Desc')
    }
  ];
  
  return (
    <section style={{ padding: '120px 7.6923%', background: '#FAFAFA' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <p style={{ color: '#E5A93D', fontSize: '12px', fontWeight: '600', letterSpacing: '2px', marginBottom: '16px', textTransform: 'uppercase' }}>
            {t('howItWorks.tagline')}
          </p>
          <h2 className="font-display" style={{ fontSize: '48px', fontWeight: '700', color: '#0D2C22', marginBottom: '16px' }}>
            {t('howItWorks.title')}
          </h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '60px' }}>
          {steps.map((step, idx) => (
            <div key={idx} style={{ borderTop: '2px solid rgba(13, 44, 34, 0.2)', paddingTop: '24px' }}>
              <div style={{ fontSize: '14px', fontWeight: '600', color: '#E5A93D', marginBottom: '12px', letterSpacing: '1px' }}>
                {step.num}
              </div>
              <h3 className="font-display" style={{ fontSize: '24px', fontWeight: '700', color: '#0D2C22', marginBottom: '12px' }}>
                {step.title}
              </h3>
              <p style={{ fontSize: '16px', color: 'rgba(13, 44, 34, 0.7)', lineHeight: '1.6' }}>
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;